import React from 'react';
import PropTypes from 'prop-types';
import { EnhancedTreeSelect } from 'mkui-ext';

const noop = () => {};

class OptionSelect extends React.Component {
  /** *******************static************************** */
  static propTypes = {
    api: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.object,
    disabled: PropTypes.bool,
    showSearch: PropTypes.bool,
  };

  static defaultProps = {
    api: noop,
    onChange: noop,
    value: null,
    disabled: false,
    placeholder: '请选择',
    showSearch: true,
  };

  /** *******************life cycle************************** */
  constructor(props) {
    super(props);
    this.state = {
      rootName: '',
      showBreadcrumb: true,
    };
  }

  /** *******************handle************************** */

  /** *******************inner method************************** */
  apiAdapter = (options = {}) => {
    const { api } = this.props;
    const params = {
      ...options,
      categoryCode: options.code,
    };
    const keyword = options.keywords;
    return new Promise(resolve => {
      if (keyword) {
        delete params.keywords;
        api({ ...params, keyword }).then(res => {
          resolve(res.items || []);
        });
      } else {
        api(params).then(res => {
          const data = this.formatData(res || {});
          if (!options.code) {
            this.setState({
              rootName: res.name,
            });
            if (!res.categories || !res.categories.length) {
              this.setState({
                showBreadcrumb: false,
              });
            }
          }
          resolve(data);
        });
      }
    });
  };

  formatData = data => {
    const categories = data.categories || [];
    const items = data.items || [];
    categories.map(category => {
      category.leaf = false;
      return category;
    });
    items.map(item => {
      item.leaf = true;
      return item;
    });
    return [
      ...categories,
      ...items,
    ];
  };

  searchResultRender = item => item.fullNames.join(' / ');

  /** *******************render************************** */
  render() {
    const { value, onChange, disabled, multiple, placeholder, showSearch, ...other } = this.props;
    const { rootName, showBreadcrumb } = this.state;
    return (
      <EnhancedTreeSelect
        {...other}
        api={this.apiAdapter}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChange}
        rootName={rootName}
        searchResultRender={this.searchResultRender}
        multiple={multiple}
        showSearch={showSearch}
        showBreadcrumb={showBreadcrumb}
      />
    );
  }
}

export default OptionSelect;
